<template>
	<div class="auth-bg"></div>
</template>

<script>
export default {
	name: 'AuthBackground',
}
</script>

<style scoped lang="scss">
.auth-bg {
	position: absolute;
	inset: 0;
	pointer-events: none;
	background-image: url('~@/assets/image/auth-bg.png');
	background-size: cover;
	background-position: center center;
}
</style>
